import { Form } from "antd"
import { Card, Flex, Skeleton, Text, Tooltip } from "components/common"
import { TitleDescription } from "components/custom"
import { t } from "i18next"
import theme from "utils/themeVars"
import cx from "clsx"
import BlockCountStepper from "../blockCountStepper"
import { formatFractionalSaleAmount } from "../utilis/fractionalSaleCalculations"
import styles from "./fractionalBlocksCard.module.less"

export default function FractionalBlocksCard({ form, blockData, loadingBlockData, blockCount, blocksTotal }) {
  const valuesLoading = loadingBlockData
  const valueSkeleton = <Skeleton active height={20} width={72} />
  const available = blockData?.availableBlockCount
  const sold = blockData?.soldFractions
  const availabilityTooltip =
    available == null
      ? null
      : sold != null && sold !== ""
        ? t("{{available}} blocks available. {{sold}} sold.", { available, sold })
        : t("{{count}} blocks available for this project.", { count: available })

  return (
    <Card
      Shadow={false}
      variant="gray"
      style={{
        borderRadius: 10,
      }}
      bodyStyle={{
        padding: 10,
        borderRadius: 10,
        backgroundColor: theme["gray100"],
      }}
      className={cx(styles.propertyBlock, "mbe-16")}
    >
      <Flex align="center" justify="space-between" gap={24}>
        <TitleDescription
          title={<Text type="secondary">{t("Price per block")}</Text>}
          description={valuesLoading ? valueSkeleton : formatFractionalSaleAmount(blockData?.pricePerBlock)}
        />

        <Flex vertical align="center" gap={6} style={{ flexShrink: 0 }}>
          <Form.Item
            name="blockCount"
            rules={[{ required: true, message: t("Please set block quantity") }]}
            style={{ margin: 0 }}
          >
            <BlockCountStepper
              count={blockCount}
              min={1}
              max={blockData?.availableBlockCount}
              disabled={valuesLoading}
              onChange={e => form.setFieldValue("blockCount", e)}
            />
          </Form.Item>
          {valuesLoading ? (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {t("Loading availability…")}
            </Text>
          ) : available != null ? (
            <Tooltip title={availabilityTooltip}>
              <Text type="secondary" style={{ fontSize: 12, cursor: "help" }}>
                {t("of {{count}} available blocks", { count: available })}
              </Text>
            </Tooltip>
          ) : null}
        </Flex>
        <TitleDescription
          title={<Text type="secondary">{t("Total amount")}</Text>}
          description={valuesLoading ? valueSkeleton : formatFractionalSaleAmount(blocksTotal)}
        />
      </Flex>
    </Card>
  )
}
